import React from 'react';

const GenericErrorText = () => {
  return (
    <div>
      {/* @TODO Get and build error screen design */}
      The data is currently unavailable. Please come back later and try again.
    </div>
  );
};

export default GenericErrorText;
